import React from 'react';
import PropTypes from 'prop-types';
import * as Headless from '@headlessui/react';
import clsx from 'clsx';

/**
 * A component that renders a field element.
 *
 * @param {Object} props - The props for the component.
 * @param {string} [props.className] - Additional class names for the field.
 * @param {Object} [props.children] - Child elements to be rendered inside the field.
 * @returns {JSX.Element} The rendered field component.
 */
export function Field({ className, ...props }) {
  return (
    <Headless.Field
      {...props}
      className={clsx(
        className,
        '[&>[data-slot=label]+[data-slot=control]]:mt-3',
        '[&>[data-slot=label]+[data-slot=description]]:mt-1',
        '[&>[data-slot=description]+[data-slot=control]]:mt-3',
        '[&>[data-slot=control]+[data-slot=description]]:mt-3',
        '[&>[data-slot=control]+[data-slot=error]]:mt-3',
        '[&>[data-slot=label]]:font-medium'
      )}
    />
  );
}

Field.propTypes = {
  className: PropTypes.string,
};
